/**
 * The engine reports the token's *full* lifetime, so refreshing at exactly that leaves
 * a window where requests are already unauthorized.
 */
const ACCESS_TOKEN_REFRESH_RATIO = 0.75;

/** Past this, `setTimeout` overflows and fires immediately. */
const MAX_TIMEOUT_MS = 2 ** 31 - 1;

/** Floor, so a nonsensical lifetime schedules a retry rather than a tight loop. */
const MIN_REFRESH_DELAY_MS = 1000;

/** @param expiresInSeconds the token's full lifetime, as reported by the engine. */
export function getRefreshDelayMs(expiresInSeconds: number) {
	const delay = expiresInSeconds * ACCESS_TOKEN_REFRESH_RATIO * 1000;

	return Math.min(Math.max(delay, MIN_REFRESH_DELAY_MS), MAX_TIMEOUT_MS);
}
